import { NgModule } from '@angular/core';

import { IntegrationSemrushModule } from './semrush/semrush.module';

@NgModule({
    imports: [IntegrationSemrushModule],
    exports: [IntegrationSemrushModule],
})
export class IntegrationsModule {}
